/*Bug #603 - Create a common component for Address fields - Author Jithin Kuriakose on 05Sept2021*/
import { Wrapper, InputItem, Input, Col, Title, CommonInputLabel } from "components";
import { getCountryCode, getFormFields, getKeyName } from "shared/utils/formlocalization";

interface Props {
    className?: React.CSSProperties | String;
    preFix?: String;
    label?: String;
    keyName?: any;/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
    onAccordionFieldChange?: any;
}

const defaultProps = {
    onAccordionFieldChange: () => { return Promise.resolve() }
};

const NameInput = (props: Props) => {
    const formFields = getFormFields(getCountryCode(), "name");
    return (
        <Wrapper>
            <CommonInputLabel label={props?.label}/>
            {formFields.map((field, index) => (
                <Col
                    lg={field?.columnSize ? field.columnSize : 6}
                    md={field?.columnSize ? field.columnSize : 6}
                    sm={12}
                    key={index}
                >
                    <InputItem
                        name={
                            props?.preFix
                                ? [props.preFix, getKeyName(props?.keyName, field?.key)]
                                : getKeyName(props?.keyName, field?.key)/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
                        }
                        label={field?.label ? field.label : ""}
                        rules={field?.rules ? [...field.rules, { validator: props.onAccordionFieldChange }] : ""}
                    >
                        <Input
                            type="text"
                            className="form-control"
                            placeholder={
                                field?.placeholder ? field.placeholder : ""
                            }
                        />
                    </InputItem>
                </Col>
            ))}
        </Wrapper>
    );
};

NameInput.defaultProps = defaultProps;
export default NameInput;

/** End Bug #603 **/
